(function (window, $) {
  const dropdownEmitter = window.useEmitter();

  /**
   * 下拉代理
   *
   * @class DropDownProxy
   * @param {Object} options - 配置选项
   * @param {jQuery} options.$input - 输入框元素
   * @param {jQuery} options.$reference - 参考元素（默认为 $input）
   * @param {string} options.trigger - 触发方式：'click' | 'hover' | 'custom'
   * @param {string} options.minWidth - 最小宽度：'auto' | 'inherit' | 具体值
   * @param {string}options.maxWidth - 最大宽度
   * @param {string} options.placement - 弹出位置：'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end'
   * @param {boolean} options.placementFixed - 是否固定 placement 方向，当位置不够时也不改变方向
   * @param {boolean}options.animation - 是否启用动画
   * @param {number} options.zIndex - 层级
   * @param {number} options.offset - 偏移距离（像素）
   */
  class DropDownProxy {
    static confirmInstances = [];
    static tooltipInstances = [];

    constructor({
      $input,
      $reference = $input,
      trigger = "click",
      minWidth = "auto",
      maxWidth,
      placement = "bottom-start",
      placementFixed = false,
      animation = true,
      offset = 0,
      selfOnly = false,
      hoverHideThreshold = 100,
      canShow = null,
      canHide = null,
      parentInstance = null,
      ignoreElement = [],
    }) {
      this.childrenInstances = [];
      this.ignoreElement = ignoreElement;

      this.emitter = window.useEmitter();

      if ($input?.length === 0) {
        throw new Error("DropDown [Error] => $input");
      }

      this.timer = null;
      this.trigger = trigger;
      this.$input = $input;
      this.$reference = $reference;
      this.placement = placement;
      this.placementFixed = placementFixed;
      this.animation = animation;
      this.isShow = false;
      this.offset = typeof offset === "number" ? offset : 0;
      this.minWidth = minWidth;
      this.maxWidth = maxWidth;
      this.selfOnly = selfOnly;
      this.hoverHideThreshold = hoverHideThreshold;
      this.canShow = canShow;
      this.canHide = canHide;
      this.parentInstance = parentInstance;
      // if (minWidth === "inherit") {
      //   minWidth = (this.$reference || this.$input).innerWidth() + "px";
      // }
      // if (maxWidth === "inherit") {
      //   maxWidth = (this.$reference || this.$input).innerWidth() + "px";
      // }

      this.$html = $(`<div style="position:fixed;display:none"></div>`);

      $("body").append(this.$html);

      this.setupEvent();
      this.setupResizeObserver();
      this.setupResizeDropdownObserver();

      if (this.parentInstance instanceof DropDownProxy) {
        this.parentInstance.addChildrenInstance(this);
      }
    }

    toggleShow(isShow = this.isShow) {
      if (isShow) {
        this.dropdownHide();
      } else {
        this.dropdownShow();
      }
    }

    /**
     * 计算并设置下拉框位置
     */
    async calcPosition() {
      await new Promise((resolve) => requestAnimationFrame(resolve));
      let minWidth = this.minWidth,
        maxWidth = this.maxWidth;
      if (minWidth === "inherit") {
        minWidth = (this.$reference || this.$input).innerWidth() + "px";
      }
      if (maxWidth === "inherit") {
        maxWidth = (this.$reference || this.$input).innerWidth() + "px";
      }

      const $reference = this.$reference;
      const $dropdown = this.$html.css({ minWidth, maxWidth });

      // 获取视口尺寸
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      // 获取下拉框尺寸
      const dropdownWidth = $dropdown.outerWidth(true);
      const dropdownHeight = $dropdown.outerHeight(true);

      // 获取参考元素的位置和尺寸
      const referenceRect = $reference[0].getBoundingClientRect();
      const referenceWidth = referenceRect.width;
      const referenceHeight = referenceRect.height;
      const referenceTop = referenceRect.top;
      const referenceLeft = referenceRect.left;

      // 计算初始位置
      const position = this.calculatePlacement(
        this.placement,
        referenceLeft,
        referenceTop,
        referenceWidth,
        referenceHeight,
        dropdownWidth,
        dropdownHeight,
      );

      // 应用位置
      $dropdown.css({
        left: position.left !== null ? position.left + "px" : "auto",
        top: position.top !== null ? position.top + "px" : "auto",
        right: "auto",
        bottom: "auto",
      });

      // 如果不固定方向，进行自适应调整
      if (!this.placementFixed) {
        const adjustedPosition = this.adjustPosition(
          position,
          referenceLeft,
          referenceTop,
          referenceWidth,
          referenceHeight,
          dropdownWidth,
          dropdownHeight,
          viewportWidth,
          viewportHeight,
        );

        $dropdown.css({
          left: adjustedPosition.left !== null ? adjustedPosition.left + "px" : "auto",
          top: adjustedPosition.top !== null ? adjustedPosition.top + "px" : "auto",
          right: "auto",
          bottom: "auto",
        });
      }
    }

    /**
     * 根据 placement 计算下拉框位置
     * @returns {Object} { left, top }
     */
    calculatePlacement(placement, refLeft, refTop, refWidth, refHeight, dropWidth, dropHeight) {
      let left = null;
      let top = null;
      const offset = this.offset;

      // 解析 placement
      const [mainPlacement, subPlacement] = placement.split("-");

      if (mainPlacement === "top") {
        // 垂直位置：在参考元素上方
        top = refTop - dropHeight - offset;

        // 水平位置
        if (subPlacement === "start") {
          left = refLeft; // 左对齐
        } else if (subPlacement === "end") {
          left = refLeft + refWidth - dropWidth; // 右对齐
        } else {
          left = refLeft + refWidth / 2 - dropWidth / 2; // 居中
        }
      } else if (mainPlacement === "bottom") {
        // 垂直位置：在参考元素下方
        top = refTop + refHeight + offset;

        // 水平位置
        if (subPlacement === "start") {
          left = refLeft; // 左对齐
        } else if (subPlacement === "end") {
          left = refLeft + refWidth - dropWidth; // 右对齐
        } else {
          left = refLeft + refWidth / 2 - dropWidth / 2; // 居中
        }
      }

      return { left, top };
    }

    /**
     * 自适应调整位置，避免溢出视口
     * @returns {Object} { left, top }
     */
    adjustPosition(
      position,
      refLeft,
      refTop,
      refWidth,
      refHeight,
      dropWidth,
      dropHeight,
      viewportWidth,
      viewportHeight,
    ) {
      let { left, top } = position;
      const offset = this.offset;
      const [mainPlacement, subPlacement] = this.placement.split("-");

      // 检查垂直方向溢出
      if (mainPlacement === "top") {
        // 如果上方空间不够，切换到下方
        if (top < 0) {
          top = refTop + refHeight + offset;
        }
      } else if (mainPlacement === "bottom") {
        // 如果下方空间不够，切换到上方
        if (top + dropHeight > viewportHeight) {
          top = refTop - dropHeight - offset;
        }
      }

      // 检查水平方向溢出
      if (left < 0) {
        // 左侧溢出，调整到视口内
        left = 0;
      } else if (left + dropWidth > viewportWidth) {
        // 右侧溢出，调整到视口内
        left = viewportWidth - dropWidth;
      }

      return { left, top };
    }

    dropdownShow() {
      if (this.isShow) return;
      if (typeof this.canShow === "function" ? !this.canShow() : false) return;

      this.$html
        .css("z-index", useZIndex("dropdown").content)
        .show()
        .off("resize")
        .on("resize", this.calcPosition.call(this));

      this.calcPosition();
      this.isShow = true;
      this.emitter.emit("toggleShow", this.isShow);
      !this.selfOnly && dropdownEmitter.emit("dropdown", this);

      this.getAllScrollParents().forEach((element) => {
        element.addEventListener("scroll", this.curriedHandleScroll, { passive: true });
      });
    }

    dropdownHide() {
      if (!this.isShow) return;
      if (typeof this.canHide === "function" ? !this.canHide() : false) return;

      const cb = () => {
        this.getAllScrollParents().forEach((element) => {
          element.removeEventListener("scroll", this.curriedHandleScroll);
        });
      };

      // if (this.animation) this.$html.slideUp(100, () => cb());
      // else {
      this.$html.hide();
      cb();
      // }

      this.isShow = false;
      this.emitter.emit("toggleShow", this.isShow);
    }

    curriedHandleScroll = (() => this.calcPosition.bind(this))();

    getScrollParents(element) {
      const parents = [];
      let current = element;

      while (current && current !== document.documentElement) {
        parents.push(current);
        current = current.parentElement;
      }
      return parents;
    }

    isScrollContainer(element) {
      const style = window.getComputedStyle(element);
      const overflowRegex = /(auto|scroll|overlay)/;
      return (
        overflowRegex.test(style.overflow) ||
        overflowRegex.test(style.overflowX) ||
        overflowRegex.test(style.overflowY)
      );
    }

    getAllScrollParents($input = this.$input) {
      const element = $input[0];
      const scrollParents = this.getScrollParents(element).filter(this.isScrollContainer);

      scrollParents.push(window);
      return [...new Set(scrollParents)]; // 去重
    }

    onElementRemoved(element, callback) {
      if (typeof MutationObserver === "undefined") return;

      const observer = new MutationObserver(() => {
        if (!document.contains(element)) {
          callback();
          observer.disconnect();
          this.resizeObserver?.disconnect();
          this.resizeDropdownObserver?.disconnect();

          if (this.parentInstance instanceof DropDownProxy) {
            this.parentInstance.removeChildrenInstance(this);
          }
        }
      });
      observer.observe(document, {
        childList: true,
        subtree: true,
      });
    }

    isDescendant(parent, child) {
      if (parent === child) return true;

      return !!(parent.compareDocumentPosition(child) & Node.DOCUMENT_POSITION_CONTAINED_BY);
    }

    setupEvent() {
      document.addEventListener(
        "click",
        (e) => {
          if (
            this.isShow &&
            !this.isDescendant(this.$html[0], e.target) &&
            !this.isDescendant(this.$input[0], e.target) &&
            !DropDownProxy.confirmInstances.some((instance) =>
              instance.isDescendant(instance.$html[0], e.target),
            ) &&
            !DropDownProxy.tooltipInstances.some((instance) =>
              instance.isDescendant(instance.$html[0], e.target),
            ) &&
            !this.childrenInstances.some((instance) =>
              instance.isDescendant(instance.$html[0], e.target),
            ) &&
            !this.ignoreElement.some((element) => instance.isDescendant($(element)[0], e.target))
          ) {
            this.toggleShow(true);
          }
        },
        true,
      );

      dropdownEmitter.on("dropdown", (instance) => {
        !this.selfOnly &&
          instance !== this &&
          !this.childrenInstances.includes(instance) &&
          this.isShow === true &&
          this.toggleShow(true);
      });

      // this.$html.on("click", (e) => e.stopPropagation());
      // this.$input.on("click", (e) => e.stopPropagation());

      this.onElementRemoved(this.$input[0], () => {
        this.isShow = false;
        this.$html.remove();
        const index1 = DropDownProxy.confirmInstances.findIndex((instance) => instance === this);
        if (index1 !== -1) DropDownProxy.confirmInstances.splice(index1, 1);
        const index2 = DropDownProxy.tooltipInstances.findIndex((instance) => instance === this);
        if (index2 !== -1) DropDownProxy.tooltipInstances.splice(index2, 1);
      });

      // 点击触发
      if (this.trigger === "click") {
        this.$input.on("click", (e) => {
          this.toggleShow();
        });
      }
      // hover触发
      else if (this.trigger === "hover") {
        this.$input.on("mouseover", (e) => {
          clearTimeout(this.timer);
          this.toggleShow(false);
        });

        this.$input.on("mouseleave", (e) => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.toggleShow(true), this.hoverHideThreshold);
        });

        if (this.trigger === "hover") {
          this.$html.on("mouseover", (e) => {
            clearTimeout(this.timer);
            this.toggleShow(false);
          });

          this.$html.on("mouseleave", (e) => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.toggleShow(true), this.hoverHideThreshold);
          });
        }
      }
    }

    /**
     * 设置 ResizeObserver 监听下拉框尺寸变化
     */
    setupResizeObserver() {
      if (typeof ResizeObserver === "undefined") return;

      let react = {};
      this.resizeObserver = new ResizeObserver((entries) => {
        if (this.isShow) {
          const curReact = entries[0].contentRect;
          if (
            curReact.width !== react.width ||
            curReact.height !== react.height ||
            curReact.top !== react.top ||
            curReact.left !== react.left ||
            curReact.right !== react.right ||
            curReact.bottom !== react.bottom ||
            curReact.x !== react.x ||
            curReact.y !== react.y
          ) {
            this.calcPosition();
            react = curReact;
          }
        }
      });

      this.resizeObserver.observe(this.$reference[0]);
    }

    /**
     * 设置 ResizeObserver 监听下拉框尺寸变化
     */
    setupResizeDropdownObserver() {
      if (typeof ResizeObserver === "undefined") return;

      let react = {};
      this.resizeDropdownObserver = new ResizeObserver((entries) => {
        if (this.isShow) {
          const curReact = entries[0].contentRect;
          if (
            curReact.width !== react.width ||
            curReact.height !== react.height ||
            curReact.top !== react.top ||
            curReact.left !== react.left ||
            curReact.right !== react.right ||
            curReact.bottom !== react.bottom ||
            curReact.x !== react.x ||
            curReact.y !== react.y
          ) {
            this.calcPosition();
            react = curReact;
          }
        }
      });

      this.resizeDropdownObserver.observe(this.$html[0]);
    }

    addChildrenInstance(instance) {
      this.childrenInstances.push(instance);
    }

    removeChildrenInstance(instance) {
      const index = this.childrenInstances.indexOf(instance);
      if (index !== -1) {
        this.childrenInstances.splice(index, 1);
      }
    }
  }

  window.DropDownProxy = DropDownProxy;
})(window, jQuery);
